import { Paper, Stack, Text, ThemeIcon, Center } from '@mantine/core';
import type { ReactNode } from 'react';

type MarketplaceComingSoonPanelProps = {
  icon: ReactNode;
  /** e.g. "Coming Soon" / "Demnächst verfügbar" */
  comingSoon: string;
  /** One short line of context for this tab */
  hint: string;
  accentColor?: string;
};

/**
 * Compact placeholder for marketplace tabs that are not live yet.
 */
export function MarketplaceComingSoonPanel({
  icon,
  comingSoon,
  hint,
  accentColor = '#228be6',
}: MarketplaceComingSoonPanelProps) {
  return (
    <Center py={{ base: 'md', sm: 'xl' }}>
      <Paper
        p={{ base: 'lg', sm: 'xl' }}
        radius="md"
        withBorder
        maw={420}
        w="100%"
        style={{
          textAlign: 'center',
          borderColor: `${accentColor}2a`,
          background: 'var(--mantine-color-body)',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)',
        }}
      >
        <Stack align="center" gap="md">
          <ThemeIcon
            size={56}
            radius="xl"
            variant="light"
            style={{
              backgroundColor: `${accentColor}18`,
              color: accentColor,
            }}
          >
            {icon}
          </ThemeIcon>
          <Text fw={700} size="xl" style={{ letterSpacing: '-0.02em' }}>
            {comingSoon}
          </Text>
          <Text size="sm" c="dimmed" lh={1.55} maw={360} mx="auto">
            {hint}
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
}
